export interface ICcCloseComplaintProps {
  open: boolean;
  complaint: ICcCloseComplaint;
  status?: string;
  onClose: () => void;
}

export interface ICcCloseComplaint {
  quick_rsa_help_id: number;
  mobile_no: string;
  vehicle_no: string;
  status: string;
  category: string;
  close_time: Date;
  remark: string;
  remark2: string;
}


export interface IDistinctDisposition {
  disposition: string | null;
}

export const initialDistinctDisposition: IDistinctDisposition = {
  disposition: null,
};

export interface IDisposition {
  quick_rsa_help_disposition_id: number | null;
  quick_rsa_help_disposition_no: number | null;
  disposition: string | null;
  sub_disposition: string | null;
  status: 'ACTIVE' | 'INACTIVE' | string; 
  remark: string | null;
  comment: string | null;
  create_dt: string | null; 
  insert_dt: string | null; 
}

export const initialDisposition: IDisposition = {
  quick_rsa_help_disposition_id: null,
  quick_rsa_help_disposition_no: null,
  disposition: null,
  sub_disposition: null,
  status: "ACTIVE",
  remark: null,
  comment: null,
  create_dt: null,
  insert_dt: null,
};
